import { useEffect, useState } from "react";
import Editor from "./Editor";

import broadcastService from "../services/broadcastService";
import useBroadcast from "../hooks/useBroadcast";

const BroadcastForm = ({ onCloseClicked }) => {
  const [value, setCurrentValue] = useState('');

  const { data: broadcast } = useBroadcast();

  useEffect(() => {
    if (!broadcast) return;

    setCurrentValue(broadcast.content);
  }, [broadcast]);

  const handleSubmit = async () => {
    try {
      await broadcastService.updateBroadcast({ broadcastData: { content: value } });

      onCloseClicked();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[700px] pb-1">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Update Broadcast</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <div className="flex flex-col gap-4 p-4">
        <Editor value={value} setCurrentValue={setCurrentValue} />

        <button
          onClick={handleSubmit}
          className="ase-button-primary h-[48px]"
        >
          Submit
        </button>
      </div>
    </div>
  )
}

export default BroadcastForm;
